import { AuthKeyType } from '@shopee-user/otp-hook-base-constants';
import { WhatsappType } from './constants';

export function getAuthenticationKeyValues({
  authKey,
  authKeyType,
  token,
}: {
  authKey: string;
  authKeyType: AuthKeyType;
  token?: string;
}): {
  phone?: string;
  email?: string;
  token?: string;
} {
  switch (authKeyType) {
    case AuthKeyType.Phone:
      /**
       * If avToken exists, prioritise avToken above phone
       */
      if (token) {
        return { token };
      }
      return { phone: authKey };
    /**
     * Email is not allowed
     */
    case AuthKeyType.Email:
    default:
      return {};
  }
}

export function getWhatsappAppsInstalledList({
  hasWhatsappBusiness,
  hasWhatsappNormal,
}: {
  hasWhatsappBusiness: boolean;
  hasWhatsappNormal: boolean;
}) {
  return [
    hasWhatsappBusiness && WhatsappType.Business,
    hasWhatsappNormal && WhatsappType.Normal,
  ].filter((x): x is WhatsappType => Boolean(x));
}
